<script>
export default {
  name: "ColorTagsinLineFormatter",
  functional: true,

  render(createElement, context) {
    //console.log("Context del formater ColorTagsinLineFormatter: ", context);
    let { rowValue, column, row } = context.data.attrs;
    //let { column } = context.data.attrs;

    let Type = String;
    let Status = String;

    switch (rowValue) {
      case "Activa":
        Type = "success";
        Status = rowValue;
        break;
      case "Inactiva":
        Type = "danger";
        Status = rowValue;
        break;
      case "ACT":
        Type = "success";
        Status = "Activo";
        break;
      case "INA":
        Type = "danger";
        Status = "Inactivo";
        break;
    }
    if (column == "UsoApp") {
      switch (rowValue) {
        case true:
          Type = "success";
          Status = "Con App";
          break;
        case false:
          Type = "danger";
          Status = "Sin App";
          break;
      }
    } else if (column == "EstadoProtalWeb") {
      switch (rowValue) {
        case true:
          Type = "success";
          Status = "Usa el Portal";
          break;
        case false:
          Type = "danger";
          Status = "No Usa el Portal";
          break;
      }
    } else if (column == "Contacted") {
      if (row.TypeOf === "llamada") {
        switch (rowValue) {
          case 1:
            Type = "success";
            Status = "Llamado";
            break;
          case 0:
            Type = "danger";
            Status = "No Llamado";
            break;
        }
      } else if (row.TypeOf === "visita") {
        switch (rowValue) {
          case 1:
            Type = "success";
            Status = "visitado";
            break;
          case 0:
            Type = "danger";
            Status = "No visitado";
            break;
        }
      }
    } else if (column == "DocumentType") {
      switch (rowValue) {
        case 1:
          Type = "success";
          Status = "Cobrado";
          break;
        case 2:
          Type = "danger";
          Status = "No Cobrado";
          break;
        case 3:
          Type = "warning";
          Status = "Nota de Credito";
          break;
      }
    } else if (column == "DocumentTypeKpiCharges") {
      // console.log("DocumentTypeKpiCharges", row.ClosedDate);

      if (row.ClosedDate == "1753-01-01T00:00:00" && row.DaysLate == 0) {
        Type = "warning";
        Status = "No Cobrado";
      } else if (row.ClosedDate != "1753-01-01T00:00:00" && row.DaysLate == 0) {
        Type = "success";
        Status = "Cobrado a Tiempo";
      } else {
        Type = "danger";
        Status = "No Cobrado a Tiempo";
      }
      // switch (row.DaysLate) {
      //   case row.DaysLate < 1:
      //     Type = "success";
      //     Status = "Cobrado a Tiempo";
      //     break;
      //   case row.DaysLate > 1:
      //     Type = "danger";
      //     Status = "No Cobrado a Tiempo";
      //     break;
      // }
    }

    return createElement(
      "el-tag",
      {
        attrs: {
          name: "",
          type: Type,
          size: "small"
        }
      },
      Status
    );
  }
};
</script>
